import { render, staticRenderFns } from "./LoadingDummy.vue?vue&type=template&id=2d56eccc&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./LoadingDummy.vue?vue&type=script&lang=ts"
export * from "./LoadingDummy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56eccc",
  null
  
)

export default component.exports